export interface LegacyCustomerSortationItem { id: string; name: string; hidden: boolean }

export const legacyCustomerSortationGroups = [
  { id: '1', name: 'Mock 기본 그룹' },
  { id: '2', name: 'Mock 2그룹' },
  { id: '3', name: 'Mock 교육 그룹' },
]

export const legacyCustomerSortations: LegacyCustomerSortationItem[] = [
  { id: 'CS-101', name: 'Mock 일반 고객', hidden: false },
  { id: 'CS-102', name: 'Mock 소개 고객', hidden: false },
  { id: 'CS-103', name: 'Mock 재방문 고객', hidden: false },
  { id: 'CS-201', name: 'Mock 미표시 고객 A', hidden: true },
  { id: 'CS-202', name: 'Mock 미표시 고객 B', hidden: true },
]
